import { createApp } from 'vue';
import SearchList from './SearchList.vue';
import { createAgonI18n } from '../../i18n';

declare const rootProps: never;

const i18n = createAgonI18n(rootProps['culture']);

createApp(SearchList, rootProps).use(i18n).mount('#search-list');
